import { once } from "./once";

/**
 * 空闲加载器
 * @param callback 
 * @param timeout 
 */
export const requestIdle = (callback: Function, timeout: number) => {

  // 只执行一次
  // @ts-ignore: 2554
  const onceCallback = once(() => {
    callback()
  })

  // 兼容
  if (window.requestIdleCallback) {
    // @ts-ignore
    window.requestIdleCallback(onceCallback, {
      timeout: timeout
    })
    setTimeout(() => {
      onceCallback();
    }, timeout + 100);

  } else {
    setTimeout(() => {
      onceCallback()
    }, timeout);
  }
}